export function isEmpty(value: unknown): boolean {
    if (value === null || value === undefined) {
        return true;
    }

    if (value instanceof Map || value instanceof Set) {
        return value.size === 0;
    }

    if (Array.isArray(value)) {
        return value.every((item) => isEmpty(item));
    }

    if (typeof value === 'object') {
        for (const key in value) {
            if (
                Object.prototype.hasOwnProperty.call(value, key) &&
                !isEmpty((value as Record<string, unknown>)[key])
            ) {
                return false;
            }
        }
        return true;
    }

    if (value === '') {
        return true;
    }

    return false;
}
